function PouzitiePlastov(){
    return(
        <div>
            Použitie  plastov
        </div>
    );
};

export default PouzitiePlastov;